<div class="line-chart">
  <apx-chart [chart]="chartOptions.chart" [colors]="chartOptions.colors" [dataLabels]="chartOptions.dataLabels"
             [grid]="chartOptions.grid" [series]="chartOptions.series" [stroke]="chartOptions.stroke"
             [title]="chartOptions.title" [xaxis]="chartOptions.xaxis"></apx-chart>
</div>
